module.exports = __webpack_public_path__ + "img/2500-3_YR_2022_Vishing.2df11139.png";